import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import CreatorStep from '../game/CreatorStep';
import StepIndicator from '../game/StepIndicator';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import Keyboard from '../ui/Keyboard';
import ShapeTextButton from '../ui/ShapeTextButton';
import UIAssetKeys from '../UIAssetKeys';
import LearnScreen from './LearnScreen';
import PrintScreen from './PrintScreen';

export default class CreatorScreen extends Phaser.Scene
{
    static get KEY() { return 'CreatorScreen'; }

    constructor()
    {
        super({ key: (CreatorScreen).KEY });
    }

    create()
    {
        const STEPS = [
            { "inst": "", "inputs": [{ "lbl": ABCyaPhaser.Localization.instance.getLocalizedString("creation.date"), "lblAlign": "top", "inputName": "date", maxCharacters: 44 }, { "lbl": ABCyaPhaser.Localization.instance.getLocalizedString("creation.address"), "lblAlign": "top", "inputName": "address", maxCharacters: 72 }] },
            { "inst": ABCyaPhaser.Localization.instance.getLocalizedString("creation.instructions"), "inputs": [{ "lbl": ABCyaPhaser.Localization.instance.getLocalizedString("creation.dear") + ":", "lblAlign": "top", "inputName": "salutation", maxCharacters: 22 }] },
            { "inst": "", "inputs": [{ "lbl": ABCyaPhaser.Localization.instance.getLocalizedString("creation.message"), "lblAlign": "top", "inputName": "body", maxCharacters: 600 }] },
            { "inst": "", "inputs": [{ "lbl": ABCyaPhaser.Localization.instance.getLocalizedString("creation.closing"), "lblAlign": "top", "inputName": "closing", maxCharacters: 44 }] },
            { "inst": "", "inputs": [{ "lbl": ABCyaPhaser.Localization.instance.getLocalizedString("creation.name"), "lblAlign": "top", "inputName": "signature", maxCharacters: 22 }] }
        ]
        this.stepInfo = STEPS;

        this.creatorBg = this.add.rectangle(0, 0, this.scale.width, this.scale.height, BG_COLORS[0]).setOrigin(0);

        this.stepIndicator = new StepIndicator(this);
        this.stepIndicator.x = 0;
        this.stepIndicator.y = 10;
        this.add.existing(this.stepIndicator);
        this.stepIndicator.alpha = 0;
        ABCyaPhaser.Tweens.addTween(this.stepIndicator, 300, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);

        this.gameKeyBoard = new Keyboard(this);
        this.gameKeyBoard.x = (this.scale.width / 2);
        this.gameKeyBoard.y = this.scale.height;
        this.add.existing(this.gameKeyBoard);
        this.gameKeyBoard.on("KEY_PRESS", this.handleKeyHit, this);

        this.envelopeIcon = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._envelope, this).setOrigin(0);
        this.envelopeIcon.x = (this.scale.width / 2) - (this.envelopeIcon.width / 2);
        this.envelopeIcon.y = this.scale.height - this.gameKeyBoard.height - this.envelopeIcon.height - 20;
        this.envelopeIcon.alpha = 0;

        this.learnBtn = new ShapeTextButton(this, ABCyaPhaser.Localization.instance.getLocalizedString("creation.help"), 0xF4805C, FontKeys._asapbold, 36, 0xFBE796);
        this.learnBtn.x = 20;
        this.learnBtn.y = this.scale.height - this.gameKeyBoard.height - this.learnBtn.getBounds().height - 50;
        this.learnBtn.alpha = 0;
        this.learnBtn.scale = 0;
        this.add.existing(this.learnBtn);
        this.learnBtn.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.toLearnScreen, this);

        this.nextBtn = new ShapeTextButton(this, ABCyaPhaser.Localization.instance.getLocalizedString("creation.next"), 0xF4805C, FontKeys._asapbold, 36, 0xFBE796);
        this.nextBtn.x = this.scale.width - this.nextBtn.getBounds().width - 20;
        this.nextBtn.y = this.scale.height - this.gameKeyBoard.height - this.nextBtn.getBounds().height - 50;
        this.nextBtn.alpha = 0;
        this.add.existing(this.nextBtn);

        this.initScreen();
    }

    handleKeyHit(e)
    {
        if (!this.curStep) return;
        if (e._keyValue == "shift") return;
        this.curStep.inputToStep(e._keyValue);
    }

    toLearnScreen()
    {
        if (this.toLearnInst != null)
        {
            this.toLearnInst.destroy();
            this.toLearnInst = null;
        }

        this.curStep.removeStep({ x: this.envelopeIcon.x, y: this.envelopeIcon.y });
        this.curStep = null;

        this.time.delayedCall(600, () => this.scene.start(LearnScreen.KEY));
    }

    initScreen()
    {
        this.initStep(gameData.creatorPageIndex);

        this.time.delayedCall(200, this.animateKeyboard, [true], this);
        ABCyaPhaser.Tweens.addTween(this.envelopeIcon, 200, { delay: 200, alpha: 1 }, Phaser.Math.Easing.Linear);
    }

    initStep(stepIndex)
    {
        gameData.creatorPageIndex = stepIndex;
        ABCyaPhaser.Tweens.addTween(this.envelopeIcon, 200, { scale: 1, angle: 0 }, Phaser.Math.Easing.Linear);

        this.curStep = new CreatorStep(this, this.stepInfo[stepIndex]);

        this.curStep.y = this.stepIndicator.y + this.stepIndicator.getBounds().height + 70;
        this.add.existing(this.curStep);
        this.children.moveTo(this.curStep, 1);
        this.curStep.setUpStep();

        this.curStepIndex = stepIndex;
        this.showBgColor(stepIndex);
        this.stepIndicator.setSelectedStep(stepIndex);

        this.time.delayedCall(1000, this.initNextBtn, null, this);
    }

    showBgColor(colorIndex)
    {
        this.creatorBg.fillColor = BG_COLORS[colorIndex];
    }

    initNextBtn()
    {
        this.input.removeDebug(this.nextBtn);
        if (this.nextBtn) this.nextBtn.destroy();
        //change btn for last step
        if (this.curStepIndex == this.stepInfo.length - 1)
        {
            this.nextBtn = new ShapeTextButton(this, ABCyaPhaser.Localization.instance.getLocalizedString("creation.view"), 0xF4805C, FontKeys._asapbold, 32, 0xFBE796);
            this.nextBtn.x = (this.scale.width / 2) - (this.nextBtn.getBounds().width / 2);
            this.nextBtn.y = this.scale.height - this.gameKeyBoard.height - 200;
        }
        else
        {
            this.nextBtn = new ShapeTextButton(this, ABCyaPhaser.Localization.instance.getLocalizedString("creation.next"), 0xF4805C, FontKeys._asapbold, 32, 0xFBE796);
            this.nextBtn.x = this.scale.width - this.nextBtn.getBounds().width - 20;
            this.nextBtn.y = this.scale.height - this.gameKeyBoard.height - this.nextBtn.getBounds().height - 50;
        }

        this.add.existing(this.nextBtn);
        this.nextBtn.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleNextBtn, this);
        this.nextBtn.alpha = 0;
        this.nextBtn.scale = 0;
        ABCyaPhaser.Tweens.addTween(this.nextBtn, 400, { alpha: 1, scale: 1 }, Phaser.Math.Easing.Bounce.Out);
        if (this.learnBtn.scaleX == 0)
        {
            ABCyaPhaser.Tweens.addTween(this.learnBtn, 400, { alpha: 1, scale: 1 }, Phaser.Math.Easing.Bounce.Out);
        }

        this.stepIndicator.on("BTN_SELECT", this.handleNavClick, this);
    }

    handleNextBtn()
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._clickSound, this);
        let complete = this.curStep.checkInputComplete();
        if (complete == true)
        {
            let letterReady = true;
            if (this.curStepIndex < this.stepInfo.length - 1)
            {

            }
            else
            {
                let needed = [];
                if (gameData.letterData['date'] == "") needed.push(0);
                if (gameData.letterData['salutation'] == "") needed.push(1);
                if (gameData.letterData['body'] == "") needed.push(2);
                if (gameData.letterData['closing'] == "") needed.push(3);
                if (gameData.letterData['signature'] == "") needed.push(4);

                if (needed.length > 0)
                {
                    letterReady = false;
                    for (let n = 0; n < needed.length; n++)
                    {
                        let stepNeeded = this.stepIndicator.steps[needed[n]];
                        ABCyaPhaser.Tweens.addTween(stepNeeded, 100, { alpha: 0.6, scale: 1.1, x: stepNeeded.x - ((stepNeeded.getBounds().width * .1) / 2), y: stepNeeded.y - ((stepNeeded.getBounds().height * .1) / 2), yoyo: true }, Phaser.Math.Easing.Linear);
                    }
                }
                else
                {
                    letterReady = true;
                }
            }

            if (letterReady == true)
            {
                this.nextBtn.alpha = 0;
                this.stepIndicator.removeAllListeners();
                this.nextBtn.removeAllListeners();
                ABCyaPhaser.Tweens.addTween(this.envelopeIcon, 200, { angle: -15, scale: 1.5 }, Phaser.Math.Easing.Quadratic.In, () => this.finishStep());
            }
        }
        else
        {
            this.curStep.highlightStepRequired(true);
        }
    }

    finishStep()
    {
        this.curStep.removeStep({ x: this.envelopeIcon.x, y: this.envelopeIcon.y });
        this.curStep = null;

        if (this.curStepIndex < this.stepInfo.length - 1)
        {
            this.time.delayedCall(600, this.initStep, [this.curStepIndex + 1], this);
        } else
        {
            //print screen
            this.time.delayedCall(1000, () => this.scene.start(PrintScreen.KEY));
        }
    }

    animateKeyboard(toShow)
    {
        if (toShow == true)
        {
            ABCyaPhaser.Tweens.addTween(this.gameKeyBoard, 1500, { y: this.scale.height - this.gameKeyBoard.height, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out);
        }
        else
        {
            ABCyaPhaser.Tweens.addTween(this.gameKeyBoard, 1500, { y: this.scale.height, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.In);
        }
    }

    handleNavClick(toIndex)
    {
        if (toIndex != this.curStepIndex)
        {
            this.nextBtn.scale = 0;
            this.stepIndicator.removeAllListeners();
            this.nextBtn.removeAllListeners();
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._clickSound, this);
            this.curStep.removeStep({ x: this.envelopeIcon.x, y: this.envelopeIcon.y });
            this.curStep = null;

            this.time.delayedCall(600, this.initStep, [toIndex], this);
        }
    }
}

const BG_COLORS = [0xE7B8D5, 0x7DCECE, 0xF8E857, 0xA1CF67, 0xE7B8D5];